import { AnimationShell, Typography } from '@/components';

export function TermsAndConditions() {
  return (
    <AnimationShell type="scale" className="mt-8 flex flex-col items-center justify-center space-y-8 text-center">
      <Typography as="h1" size="heading-1" color="primary" weight="semibold">
        <b>NTEASER</b>
      </Typography>
      <Typography as="h1" size="heading-1" color="primary" weight="semibold">
        <b>Terms And Conditions</b>
      </Typography>

      <div className="mx-20 text-left">
        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          <b>1. INTRODUCTION</b>
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          These Terms and Conditions (&quot;Terms&quot;) govern access to and use of the nTeaser platform
          (&quot;Platform&quot;), which includes the websites www.nteaser.com and app.nteaser.com (collectively, the
          &quot;Website&quot;), owned and operated by NTEASER PLATFORM S.L. (&quot;nTeaser&quot;), a company registered
          in Spain.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-8">
          By accessing or using the Platform, the user (&quot;User&quot;) declares that they have read, understood, and
          accepted these Terms and the Privacy Policy, both on their own behalf and on behalf of the company they
          represent. Use of the Platform implies full acceptance of these Terms, including any future modifications,
          updates or upgrades made by nTeaser.
        </Typography>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          <b>2. DESCRIPTION AND PURPOSE OF THE PLATFORM</b>
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          nTeaser is a digital marketplace designed to connect professionals and companies involved in the renewable
          energy sector. Through the Platform, the User can identify opportunities, express interest in renewable energy
          projects and assets (including solar, wind, storage, hydrogen, etc.), and access specialized services and
          market insights.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          nTeaser offers two access plans:
        </Typography>
        <ul className="ml-8 list-decimal">
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal">
              <b>Free access Plan: </b>Allows Users to browse Projects available on the Platform and submit non-binding
              Expressions of Interest.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
              <b>Business Plan: </b>Includes all features of the Free Access Plan and additionally provides enhanced
              functionalities such as market data and transaction benchmarks, team support, strategic recommendations,
              and access to consulting sessions, among others.
            </Typography>
          </li>
        </ul>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-8">
          The Platform does not participate in the negotiation or execution of agreements between Users, nor does it
          provide legal, financial, or investment advice. However, nTeaser may act as an independent facilitator to
          support communication between Users and reserves the right to request updates or information regarding the
          progress and outcome of any transaction initiated through the Platform, solely for compliance and fee
          collection purposes.
        </Typography>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          <b>3. PLATFORM REGISTRATION AND USE</b>
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          To access the Platform, the User must register by providing accurate and truthful information. By doing so,
          confirms that is legally authorized to act both in his own name and on behalf of the company they represent,
          and that they accept these Terms and the Privacy Policy.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The User is solely responsible for the content uploaded and actions performed on the Platform. By submitting a
          project, the User declares that they are either the legal owner of the asset, a duly authorized employee of
          the owning entity, or hold formal authorization or a valid sale mandate from the owner. Likewise, when
          submitting an Expression of Interest, the User confirms that is duly authorized to do so on behalf of
          themselves, their company, or a third party they represent.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          As part of its review process, nTeaser may request documentation or information to verify that the User
          submitting Projects or Expressions of Interest is legitimately entitled to do so. This step is essential to
          maintain the transparency and credibility of the Platform.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The User agrees to make proper and lawful use of the Platform. Any attempt to manipulate, misuse, or interfere
          with the integrity, security, or functioning of the Platform is strictly prohibited.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          nTeaser reserves the right to suspend or terminate a User&apos;s access at any time and without prior notice
          if it detects any misuse, breach of these Terms, or behaviour that does not align with the purpose and values
          of the Platform.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-8">
          Users may request account deactivation at any time by contacting:{' '}
          <a href="mailto:contact@nteaser.com">contact@nteaser.com</a>.
        </Typography>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          4. USER RESPONSIBILITIES
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The User agrees to use the Platform lawfully, in good faith, and without causing harm to nTeaser, other Users,
          or third parties. It is strictly prohibited to use the Platform for illegal purposes, disrupt its operation,
          or attempt to access, modify or interfere with its infrastructure or other Users&apos; data.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The User is responsible for keeping their credentials secure and for all actions taken through their account.
          In case of unauthorized access, loss or theft, the User must notify nTeaser immediately.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The User declares that the information provided to the Platform is true, accurate, and up to date. Any attempt
          to provide misleading or false information may result in suspension or termination of access.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The Platform and its underlying software may not be copied, modified, reverse engineered or exploited without
          express written authorization from nTeaser.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          Only individuals of legal age may use the Platform.
        </Typography>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-8">
          5. FEES AND PAYMENT METHOD
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The User may access the Platform under a Free Access Plan or upgrade to a Business Plan. The Free Access Plan
          is free of charge. The Business Plan requires payment, which can be made via Stripe, SEPA debit, or by
          requesting an invoice and paying by bank transfer. All subscription payments are processed securely through
          third-party providers, and nTeaser does not store any payment details. Further information on the processing
          of personal data can be found in the Privacy Policy.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          By submitting an Expression of Interest (EOI), the User expressly acknowledges and accepts that a success fee
          (&quot;Contact Fee&quot;) may apply to transactions resulting from connections made through the Platform,
          under the terms described below.
        </Typography>
        <Typography as="h3" size="body-2" color="primary" weight="semibold" className="mb-4 ml-8">
          a) Transactions relating to a project published on the Platform (Buyer pays)
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          When the User acts as Buyer in a transaction for a project published on the Platform, the Contact Fee shall
          be:
        </Typography>
        <ul className="ml-8 list-disc">
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              1% of the equity value, if the project includes project finance or any other form of structured debt
              (including, without limitation, senior debt, mezzanine, or bridge financing).
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              1% of the total transaction price, in all other cases, including any project at pre-construction stage or
              any asset without project finance.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              Subject to a minimum of 500 € per MW, calculated in MWp for solar PV projects.
            </Typography>
          </li>
        </ul>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The Contact Fee becomes fully due and payable at the moment the definitive transaction agreement is signed
          (including any SPA, SHA, DSA, financing agreement or equivalent). If the final value is not determined at
          signing, the fee shall be calculated on the best available estimate and adjusted once the final value is
          confirmed.
        </Typography>
        <Typography as="h3" size="body-2" color="primary" weight="semibold" className="mb-4 ml-8">
          b) Seller fees under separate agreement
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          In certain cases, the Seller may be required to pay fees or other remuneration to nTeaser, in accordance with
          the terms of a separate sale or mandate agreement executed between the Seller and nTeaser, if any.
        </Typography>
        <Typography as="h3" size="body-2" color="primary" weight="semibold" className="mb-4 ml-8">
          c) Applicability regardless of transaction structure
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The Contact Fee applies irrespective of the legal or contractual structure of the transaction, including share
          deals, asset deals, joint ventures, development service agreements, shareholder agreements, options, rights
          assignments, debt or financing arrangements, or any other structure producing equivalent economic effect. It
          also applies to all components of the consideration, including fixed, variable, deferred, contingent,
          milestone-based or earn-out payments.
        </Typography>
        <Typography as="h3" size="body-2" color="primary" weight="semibold" className="mb-4 ml-8">
          d) Reporting and cooperation
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The User commits to inform nTeaser of any negotiation, signing or closing resulting from connections made
          through the Platform, including when acting as Buyer or Seller, and to provide all information necessary for
          invoicing and verification. Failure to comply constitutes a material breach of these Terms.
        </Typography>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          6. INTELLECTUAL AND INDUSTRIAL PROPERTY
        </Typography>
        <Typography as="h3" size="body-2" color="primary" weight="semibold" className="mb-4 ml-8">
          a) License grant
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          Subject to the compliance with these Terms of Use, nTeaser will grant the User a limited, revocable,
          non-exclusive, non-transferable license to access and use the Platform, solely in connection with the purpose
          of the Platform as established in these Terms.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          In addition, the User by using the Platform or providing any nTeaser Data through the Platform, shall grant a
          worldwide, non-exclusive, transferable, assignable, royalty-free, fully paid-up license to use, reproduce,
          adapt, translate and make derivative works of all such data in whole or in part solely for the purpose of
          supporting and enhancing the Platform. For more information on the processing of data that may be carried out
          by nTeaser, the User may refer to the Privacy Policy.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          nTeaser expressly reserves all rights in the Platform not granted to User herein.
        </Typography>
        <Typography as="h3" size="body-2" color="primary" weight="semibold" className="mb-4 ml-8">
          b) Platform ownership
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          nTeaser shall own all intellectual and industrial property rights over the Platform, including, without
          limitation, all software used herein, the graphic design, programming and structure of the Platform,
          documents, as well as other rights and know-how related the Platform (including any modifications or
          enhancements) and all associated rights under copyright, trademarks and patents (hereinafter the
          &quot;Content&quot;).
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The User will not challenge nTeaser&apos;s ownership of the Platform and will not alter or delete any
          copyright notices or trademarks included in the Platform. All rights in relation to such Content are reserved
          and express permission must be requested to nTeaser for its use and exploitation not expressly provided for in
          these Terms.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          Any use of the Content for which nTeaser has not given express authorization, whether directly or indirectly
          for profit or not, including downloading, storage, transmission, public disclosure, distribution, reproduction
          or transformation, reuse, the use of scraping, data mining, data harvesting or similar techniques, for private
          or commercial purposes, in whole or in part, is expressly prohibited. It is expressly stated that in
          accordance with art. 67 inc 3 of Royal Decree Law 24/2021, nTeaser reserves the right to use the works, thus
          not authorizing the mining of texts and data.
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-8">
          The User agrees to: (i) serve as a reference for nTeaser; (ii) collaborate on case studies or other marketing
          material.
        </Typography>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          7. USER WARRANTIES
        </Typography>
        <Typography as="h3" size="body-2" color="primary" weight="semibold" className="mb-4 ml-8">
          a) General warranties
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          By using the Platform, the User represents and warrants that:
        </Typography>
        <ul className="ml-8 list-disc">
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              They are of legal age and have the legal authority to act on their own behalf and on behalf of the company
              or third party they represent.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              They will use the Platform in good faith and in accordance with applicable laws and these Terms.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              All information they provide on the Platform is true, accurate, complete and up to date.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              They understand and accept that nTeaser does not provide legal, financial, or investment advice and that
              they act under their own responsibility at all times.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
              They are solely responsible for making their own investment decisions and will not hold nTeaser or the
              Platform liable for any outcomes, including potential profits or losses, resulting from any transaction
              initiated through the Platform.
            </Typography>
          </li>
        </ul>
        <Typography as="h3" size="body-2" color="primary" weight="semibold" className="mb-4 ml-8">
          b) Warranties when uploading a project
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          When uploading a project, the User additionally declares and guarantees that:
        </Typography>
        <ul className="ml-8 list-disc">
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              They are either the legal owner of the project or asset, or have a valid and demonstrable authorization or
              mandate from the owner to initiate its sale.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              They have obtained all necessary consents, permits and authorizations to share the project on the
              Platform.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              The project information is truthful, accurate and legally compliant.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              They will notify nTeaser promptly of any material change or inaccuracy that may affect the project&apos;s
              value or status.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
              They will inform nTeaser of the progress of any negotiations and the outcome of any transaction resulting
              from contacts initially established through the Platform, and will use their best efforts to ensure
              compliance with the applicable Contact Fee obligations.
            </Typography>
          </li>
        </ul>
        <Typography as="h3" size="body-2" color="primary" weight="semibold" className="mb-4 ml-8">
          c) Warranties when submitting an Expression of Interest (EOI)
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          When submitting an Expression of Interest, the User further declares and guarantees that:
        </Typography>
        <ul className="ml-8 list-disc">
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              They are duly authorized to express interest on their own behalf, on behalf of their company, or of a
              third party they represent.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              They have full legal capacity to enter into the potential transaction and, if applicable, negotiate and
              formalize a future agreement.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              They will provide any information reasonably requested by nTeaser to ensure transparency and proper
              evaluation of the opportunity.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
              They understand that sending an EOI implies acceptance of the Contact Fee terms if the transaction is
              successfully signed.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              They agree to promptly inform nTeaser of the outcome of any transaction resulting from contacts made
              through the Platform, including the signing date and final transaction value.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              They expressly acknowledge and accept that any applicable Contact Fee shall be payable in accordance with
              Section 5 of these Terms, where applicable.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-8">
              They understand that failure to report the transaction or to make payment will constitute a material
              breach of these Terms and may result in legal action.
            </Typography>
          </li>
        </ul>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          8. WARRANTY AND LIABILITY DISCLAIMER
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          a) The features and services on the Platform are provided on an &quot;AS IS&quot; and &quot;AS AVAILABLE&quot;
          basis, and nTeaser hereby expressly disclaims any and all warranties, express or implied, including but not
          limited to any warranties of condition, quality, durability, performance, accuracy, reliability,
          merchantability or fitness for a particular purpose. All such warranties, representations, conditions,
          undertakings, and terms are hereby excluded.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          b) nTeaser makes no representations or warranties about the validity, accuracy, correctness, reliability,
          quality, stability, completeness or correctness of any information provided on or through the Platform.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          c) Any material downloaded or otherwise obtained through the Platform is done at each User&apos;s sole
          discretion and risk and each User is solely responsible for any damage to its computer system or loss of data
          that may result from the download of any such material. No advice or information, whether oral or written,
          obtained by any User from nTeaser or through or from the Platform shall create any warranty not expressly
          stated herein.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          d) Under no circumstances shall nTeaser be held liable for any delay or failure or disruption of the content or
          services delivered through the Platform resulting directly or indirectly from acts of nature, forces or causes
          beyond its reasonable control, including without limitation, Internet failures, computer, telecommunications
          or any other equipment failures, electrical power failures, strikes, labor disputes, riots, insurrections,
          civil disturbances, shortages of labor or materials, fires, flood, storms, explosions, war, governmental
          actions, orders of domestic or foreign courts or tribunals or non-performance of third parties.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          e) nTeaser shall not be liable for direct or indirect damages or any damages whatsoever (including but not
          limited to damages for loss of profits or savings, business interruption, loss of information), whether in
          contract, negligence, tort, strict liability or otherwise or any other damages resulting from any of the
          following:
        </Typography>
        <ul className="ml-8">
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              - the use or the inability to use the Platform;
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              - any defect in data, information or services purchased or obtained from a User or a third-party service
              provider through the Platform;
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              - violation of third party rights or claims or demands that Users&apos; Offer may violate or may be
              asserted to violate third party rights;
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
              - or claims by any party that they are entitled to defense or indemnification in relation to assertions of
              rights, demands or claims by third party rights claimants;
            </Typography>
          </li>
        </ul>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-8">
          To the maximum extent permitted by applicable law, nTeaser shall not be liable for any indirect or
          consequential damages or lost profits including, but not limited to, any consequential damages, work stoppage,
          breakdown, failure or loss, or for any claim by any third party as a result of the foregoing. nTeaser&apos;
          liability for damages arising out of these Terms and Conditions however caused, regardless of the form of
          action, whether in contract or tort, shall be limited to, at most, the Contact Fee received by nTeaser in
          connection with the transaction from which liability has arisen.
        </Typography>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          9. INDEMNITY
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          a) User hereby agrees to indemnify and hold nTeaser, its affiliates, directors, officers and employees
          harmless, from any and all losses, claims, liabilities (including reasonable legal costs on a full indemnity
          basis) which may arise:
        </Typography>

        <ul className="ml-8 list-disc">
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              From User&apos;s use of the Platform (including but not limited to the display of such User&apos;s
              information on the Platform);
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              From breach of these Terms.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-2">
              From User&apos;s breach of any representations and warranties made by User to nTeaser, including but not
              limited to those set forth in Sections 5 above.
            </Typography>
          </li>
          <li>
            <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
              Directly or indirectly, as a result of any claims asserted by third party rights claimants or other third
              parties relating to products offered or displayed on the Platform. Each User hereby further agrees that
              nTeaser is not responsible and shall have no liability to it, for any material posted by others, including
              defamatory, offensive or illicit material and that the risk of damages from such material rests entirely
              with each User. nTeaser reserves the right, at its own expense, to assume the exclusive defense and
              control of any matter otherwise subject to indemnification by User, in which event User shall cooperate
              with nTeaser in asserting any available defenses.
            </Typography>
          </li>
        </ul>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-8">
          b) Provided that the User who first becomes aware of such circumstance immediately notifies nTeaser in writing
          of such claim, gives nTeaser full control of the defense and legal direction of the claim, immediately
          provides nTeaser with all reasonably available information and assistance, and has not compromised or settled
          such claim.
        </Typography>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          10. END OF THE RELATIONSHIP
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          Without affecting any other right or remedy available to it, nTeaser may terminate its relationship with
          immediate effect if the User commits a material breach of any other term of these Terms and Conditions, or if
          nTeaser believes that the User is misusing the Platform or does not meet the intended user profile. Upon
          termination, all rights granted to The User under these Terms shall cease immediately.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-8">
          On termination of the relationship: (a) the right granted under clause 6.a) (right to permit User to use the
          Platform) and all other licenses granted under or pursuant to these Terms and Conditions shall immediately
          terminate; (b) all User&apos;s rights to access and use the Platform shall cease immediately; (c) User shall
          return and make no further use of any confidential information, which shall be returned or destroyed, unless
          retention of any such item is required under the applicable laws; (d) any rights, remedies, obligations or
          liabilities of the Parties that have accrued up to the date of termination, including the right to claim
          damages in respect of any breach of the agreement which existed at or before the date of termination shall not
          be affected or prejudiced; and any provision of these Terms and Conditions which expressly or by implication
          is intended to come into or continue in force on or after termination of these Terms and Conditions including
          the provisions on Intellectual and Industrial Property, Data Protection, Confidentiality, Warranty and
          Liability Disclaimer, Indemnity, and Governing Law and Jurisdiction.
        </Typography>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          11. DATA PROTECTION
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The personal data collected through the Platform—such as registration information, access logs,
          communications, and any data exchanged between Users and nTeaser—will be processed by NTEASER PLATFORM S.L.,
          as the data controller, in accordance with the applicable data protection regulations, including the General
          Data Protection Regulation (EU) 2016/679 (GDPR).
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The data will be used exclusively for the operation, management, and improvement of the Platform and its
          services, as well as to facilitate communication between Users. All data will be treated confidentially and in
          accordance with our Privacy Policy and Cookies Policy.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-8">
          Users may exercise their data protection rights at any time, including access, rectification, erasure,
          objection, limitation of processing, and data portability, by contacting{' '}
          <a href="mailto:contact@nteaser.com">contact@nteaser.com</a>.
        </Typography>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          12. CONFIDENTIALITY
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          Each Party agrees, during the execution of these Terms and thereafter, to keep confidential, and not to use
          for its own purposes (other than implementation of these Terms) nor without the prior written consent of the
          other to disclose to any third party (except its professional advisors under obligations of confidentiality)
          any information of a confidential nature (including trade secrets and information of commercial value) which
          may become known to such Party from the other Party and which relates to the other Party or any of its
          customers, suppliers or other trading partners. Without limiting the generality of this clause, the technology
          and design of the Platform and the Platform services and the Content shall constitute confidential information
          of nTeaser.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The restrictions above shall not apply to the extent that: (i) such information is public knowledge or already
          known to such Party at the time of disclosure, or subsequently becomes public knowledge, in each case other
          than by breach of this Platform Agreement; (ii) subsequently comes lawfully into the possession of such Party
          from a third Party; or (iii) such information is required to be disclosed by law or competent authority.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-8">
          Neither Party shall be responsible for any loss, destruction, alteration or disclosure of confidential
          information caused by any third Party.
        </Typography>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          13. SUPPORT
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          nTeaser shall provide reasonable support services to Users regarding the Platform and its functionalities,
          subject to these Terms. The support services may include assistance with technical issues, clarifications on
          the Platform features and general guidance related to the use of the Platform.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          nTeaser will endeavor to respond to the User inquiries and requests for support within a reasonable timeframe,
          but response times may vary based on the complexity and volume of requests. Users may report to nTeaser any
          incident related to the use of the Platform at: <a href="mailto:clients@nteaser.com">clients@nteaser.com</a>.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          Support services will be provided on a best-effort basis and may be subject to certain limitations. nTeaser
          does not guarantee that all support inquiries or issues will be resolved, and it reserves the right to
          determine the level and extent of support provided.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-8">
          nTeaser&apos;s support services do not extend to general business, investment or legal advice. Users are
          responsible for making their own investment decisions and seeking professional advice when necessary.
        </Typography>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          14. THIRD PARTIES LINKS
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          The Platform may include links to third-party websites or content, including recommended service providers.
          nTeaser is not responsible for the content, accuracy, or availability of any external websites or materials
          not created by nTeaser.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          Any relationship, contract or service contracted by the User with these third parties is entirely separate
          from nTeaser. nTeaser does not act as intermediary and offers no guarantees regarding such third-party
          services.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-8">
          In compliance with Article 17 of Law 34/2002 on Information Society Services and Electronic Commerce (LSSI),
          nTeaser will remove or block access to any unlawful or infringing content as soon as it becomes aware of its
          existence.
        </Typography>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          15. MODIFICATIONS TO THE TERMS
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          nTeaser reserves the right to modify or update these Terms at any time, with prior notice to Users through the
          Platform&apos;s notification system, at least 15 days before the changes take effect.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-8">
          Continued use of the Platform after such notice shall constitute acceptance of the new Terms.
        </Typography>

        <Typography as="h3" size="title" color="primary" weight="semibold" className="mb-4">
          15. GOVERNING LAW AND JURISDICTION
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          These Terms and any dispute or claim arising out of or in connection with it or its subject matter or
          formation (including non-contractual disputes or claims) shall be governed by and construed in accordance with
          the laws of Spain.
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          Each Party irrevocably agrees that the courts of the city of Madrid shall have exclusive jurisdiction to
          settle any dispute or claim arising out of or in connection with these Terms or its subject matter or
          formation (including non-contractual disputes or claims).
        </Typography>

        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-4">
          Last update: December 2025
        </Typography>
        <Typography as="p" size="body-2" color="secondary" weight="normal" className="mb-8">
          Contact email: contact@nteaser.com
        </Typography>
      </div>
    </AnimationShell>
  );
}
